import { render, staticRenderFns } from "./charteredFrame.vue?vue&type=template&id=57b867ea"
import script from "./charteredFrame.vue?vue&type=script&lang=js"
export * from "./charteredFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports